import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AdminService } from '../../service/admin.service';
import { HttpClientModule } from '@angular/common/http';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-product-to-company',
  templateUrl: './product-to-company.page.html',
  styleUrls: ['./product-to-company.page.scss'],
})
export class ProductToCompanyPage implements OnInit {

  errorMessage: string = '';
  companyId: any;
  company: any;
  tradeName: String;
  name: String;
  selectedCompany: any = null;
  document: any;
  socialReason: String;
  companies: any[] = [];
  providers: any[] = [];
  showTable = false;
  showProvidersTable = false;
  selectAll = false;
  showHead = true;



  constructor(
    private adminService: AdminService,
    public alertController: AlertController
  ) { }

  ngOnInit() {
  }


  findCompany(form: NgForm) {
    this.showProvidersTable = false;
    if (form.valid) {
      console.log('ID de la compañía:', form.value.companyId);
      const searchCriteria = {
        companyId: this.companyId,
        name: this.name,
        document: this.document,
        socialReason: this.socialReason
      };
      const isAnyFieldFilled = Object.values(searchCriteria).some(value => value);
      if (isAnyFieldFilled) {
        this.adminService.findCompany(searchCriteria).subscribe(
          (results: any) => {
            this.companies = results;
            this.showTable = true; 
            this.errorMessage = '';
          },
          error => {
            this.errorMessage = 'Error al buscar la compañía';
            this.showTable = false; 
          }
        );
      } else {
        this.adminService.getCompanies().subscribe(
          (results: any) => {
            this.companies = results;
            this.showTable = true; 
            this.errorMessage = '';
          },
          error => {
            this.errorMessage = 'Error al buscar la compañía';
            this.showTable = false; 
          }
        );

      const companyId = form.value.companyId;
      this.adminService.getCompanyById(companyId).subscribe(
        data => {
          console.log('Respuesta del servidor:', data);
          this.errorMessage = '';
        },
        error => {
          console.error('Error al obtener la compañía:', error);
          this.errorMessage = error.error.message || 'Error al buscar la compañía';
          this.presentAlert(error.error.message || 'Error al buscar la compañía');
        }
      );
    }
  }
  }

  async presentAlert(errorMessage: string) {
    const alert = await this.alertController.create({
      header: 'Error',
      message: errorMessage,
      buttons: ['OK']
    });
  
    await alert.present();
  }

  showProviders(company) {
    this.selectedCompany = company;
    this.showTable = false;
    this.showHead = false;
    this.showProvidersTable = true;
    this.adminService.getProvidersCompanies(company.companyId).subscribe(
      (results: any) => {
        this.providers = results.map(provider => ({
            ...provider,
            state: provider.state === 1,
            changed: false
        }));
        this.errorMessage = '';
      },
      error => {
        this.errorMessage = 'Error al buscar la compañía';
      })
  }

  onToggleChange(provider) {
    const initialState = provider.initialState; 

    provider.changed = !provider.changed;
    if ((provider.state === 1 && !provider.changed) || (provider.state === 2 && provider.changed)) {
      provider.changed = !provider.changed;
    } 
    provider.state = provider.changed ? (provider.state === 1 ? 2 : 1) : provider.state;
    provider.changed = provider.state !== initialState;


    console.log('Toggle changed for provider:', provider);
  }

  toggleAllProviders() {
    this.selectAll = !this.selectAll;
    this.providers.forEach(provider => {
      provider.state = this.selectAll ? 1 : 2;
      provider.changed = true;
      if (!this.selectAll) {
        provider.state = 2;
    }
    });
  }

  async saveProvidersAssignments() {
    const alert = await this.alertController.create({
      header: 'Confirmar',
      message: '¿Está seguro de guardar los cambios?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Guardar',
          handler: () => {
            this.updateProviders();
          }
        }
      ]
    });
    await alert.present();
    this.showHead = true;

  }


  updateProviders() {
    const modifiedProviders = this.providers.filter(provider => provider.changed);
    if (modifiedProviders.length === 0) {
      console.log('No hay cambios para guardar');
      return;
    }
    const RegisteredBy = localStorage.getItem("user_id");
    if (!RegisteredBy) {
      console.error('User ID no está disponible');
      return;
    }
    const providersToUpdate = modifiedProviders.map(provider => ({
      providerId: provider.providerId,
      companyId: this.selectedCompany.companyId,
      providerCompanyId: provider.providerCompanyId,
      state: provider.state ? 1 : 2,
      registeredBy: parseInt(RegisteredBy)
    }));
    this.adminService.updateProvidersCompanies(providersToUpdate).subscribe(
      (response) => {
          console.log('Respuesta del servidor:', response);
          this.presentAlert2('Exitoso',response);
      },
      error => {
          console.error('Error al actualizar asignaciones', error);
      }
  );
  }

  async presentAlert2(header: string, message: string) {
    const alert = await this.alertController.create({
        header: header,
        message: message,
        buttons: ['OK']
    });

    await alert.present();
}

}
